const DefaultRequestConst = {
    asc: true,
    limit: 250,
    page: 0,
    search:'',
    sort: 'updateTime'
};

export default DefaultRequestConst;